import { Dispatch } from 'redux';
import { documentInternalApi, monitoringAlertInternalApi, noteInternalApi, personInternalApi } from '../apis';
import { fetchAlertsSuccess, fetchDocumentsSuccess, fetchNotesSuccess, fetchPersonSuccess } from './amlReducer';
import { showFeedback } from '../feedback/feedbackReducer';
import { NotesModalFormValues } from './NotesModal';
import { ApiSortDirection } from '../api';
import store from '../store/store';
import { NoteOption } from './amlFiltersReducer';
import { InternalApiSortDirection } from '../api-internal';

export const fetchPerson = (personId: string) => async (dispatch: Dispatch) => {
  const person = await personInternalApi.findPersonByIdInternal({ personId });
  dispatch(fetchPersonSuccess(person));
};

export const fetchNotes =
  (
    personId: string,
    page = 0,
    size = 20,
    selected: NoteOption = store.getState().amlFilters.notes,
    query?: string | undefined,
    orderBy?: string,
    direction?: ApiSortDirection
  ) =>
  async (dispatch: Dispatch) => {
    const notes = await noteInternalApi.findAllNotes({
      personId,
      page,
      size,
      query,
      orderBy,
      direction: direction as unknown as InternalApiSortDirection,
      type: selected?.key,
    });
    dispatch(fetchNotesSuccess(notes));
  };

export const saveNote =
  (personId: string, { id, content, alertId }: NotesModalFormValues) =>
  async (dispatch: Dispatch): Promise<void> => {
    const apiNote = {
      id,
      content,
      alertId,
    };
    if (id === undefined) {
      const { id } = await noteInternalApi.addNote({ personId, apiNote });
      fetchNotes(personId)(dispatch);
      dispatch(showFeedback({ message: `Note #${id} added!`, success: true }));
    }
  };

export const fetchDocuments =
  (
    personId: string,
    page: number,
    size: number,
    query?: string | undefined,
    orderBy?: string,
    direction?: ApiSortDirection
  ) =>
  async (dispatch: Dispatch) => {
    const documents = await documentInternalApi.findAllDocuments({
      personId,
      page,
      size,
      query,
      orderBy,
      direction: direction as unknown as InternalApiSortDirection,
    });
    dispatch(fetchDocumentsSuccess(documents));
  };

export const uploadDocuments = (files: File[] | null, personId: string) => async (dispatch: Dispatch) => {
  if (files !== null) {
    await Promise.all(
      files.map(async (file) => {
        return await documentInternalApi.uploadDocument({
          personId,
          file,
        });
      })
    );

    const message = files.length === 1 ? 'Document uploaded' : `${files?.length} documents uploaded`;

    dispatch(
      showFeedback({
        message: message,
        success: true,
      })
    );
  }
};

export const fetchAlerts =
  (
    personId: string,
    page: number,
    size: number,
    query?: string | undefined,
    orderBy?: string,
    direction?: ApiSortDirection
  ) =>
  async (dispatch: Dispatch) => {
    const alerts = await monitoringAlertInternalApi.findAllAlertsInternal({
      personId,
      page,
      size,
      query,
      orderBy,
      direction: direction && InternalApiSortDirection[direction],
    });
    dispatch(fetchAlertsSuccess(alerts));
  };
